<template>
  <div style="cursor:pointer" @click.prevent="downloadFiles(row)" >
    <span>Download </span>
    <Icon type="md-arrow-round-down" size="20" style="cursor:pointer" />
  </div>
</template>

<script>
  export default {
    props: {
      row: {
        type: Object
      }
    },
    methods: {
      downloadFiles(row) {
        
        this.$store.dispatch('getUserById', row.id)
        .then((res) => {  

          if(res.data.kyc_pictures) {
            for(let key in res.data.kyc_pictures) {
              
              if (res.data.kyc_pictures[key] != '') {
                window.open(res.data.kyc_pictures[key])
              } else {
                this.$Message.error({
                  content: "Sorry this user has no pictures"
                })
              }

            }
          } else { 
            this.$Message.warning({
              content: 'This user has no photos.',
              duration: 5
            })
          }
        })
        .catch(err => {
          this.$Message.error({
            content: err.response.data.error,
            duration: 5
          })          
        }) 
      }
    }
  }
</script>

